/* Lavish Home theme. No cart: every product links out to Amazon. */
(function () {
  'use strict';

  function money(x) { return x; }

  function initProduct() {
    // Scope to the document, not to .pdp. The variant data and the sticky bar
    // live outside that element, so root-scoped lookups found nothing and the
    // whole init bailed out before binding any handler.
    var dataEl = document.querySelector('[data-variant-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var ctas = [].slice.call(document.querySelectorAll('[data-amazon-cta]'));
    var prices = [].slice.call(document.querySelectorAll('[data-price]'));
    var wasEls = [].slice.call(document.querySelectorAll('[data-compare]'));
    var saveEls = [].slice.call(document.querySelectorAll('[data-save]'));
    var asinEl = document.querySelector('[data-asin]');
    var mainImg = document.querySelector('[data-main-image]');
    var colorLbl = document.querySelector('[data-color-label]');
    var sizeLbl = document.querySelector('[data-size-label]');
    var buttons = [].slice.call(document.querySelectorAll('[data-variant]'));

    function select(id) {
      var v = data[id];
      if (!v) return;
      ctas.forEach(function (a) { if (v.url) a.setAttribute('href', v.url); });
      prices.forEach(function (el) { el.textContent = v.price; });
      wasEls.forEach(function (el) {
        if (v.compare) { el.textContent = v.compare; el.hidden = false; }
        else { el.hidden = true; }
      });
      saveEls.forEach(function (el) { el.hidden = !v.compare; });
      if (asinEl && v.sku) asinEl.textContent = 'ASIN ' + v.sku;
      if (mainImg && v.image) mainImg.setAttribute('src', v.image);
      if (colorLbl && v.options && v.options[0]) colorLbl.textContent = v.options[0];
      if (sizeLbl && v.options && v.options[1]) sizeLbl.textContent = v.options[1];
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-variant') === String(id)));
      });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    // which gallery images belong to which variant, by ASIN
    var vimgMap = {};
    var vimgEl = document.querySelector('[data-vimg]');
    if (vimgEl) {
      var raw = '';
      try { raw = JSON.parse(vimgEl.textContent) || ''; } catch (e) { raw = ''; }
      raw.split(';').forEach(function (part) {
        var bits = part.split(':');
        if (bits.length === 2 && bits[1]) {
          vimgMap[bits[0]] = bits[1].split(',').map(function (x) { return parseInt(x, 10); });
        }
      });
    }

    function showThumbsFor(sku) {
      var want = vimgMap[sku];
      var all = [].slice.call(document.querySelectorAll('[data-thumb-index]'));
      if (!all.length) return;
      if (!want || !want.length) {
        all.forEach(function (t) { t.hidden = false; });
        return;
      }
      all.forEach(function (t) {
        var i = parseInt(t.getAttribute('data-thumb-index'), 10);
        t.hidden = want.indexOf(i) === -1;
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var id = b.getAttribute('data-variant');
        select(id);
        var v = data[id];
        if (v && v.sku) showThumbsFor(v.sku);
      });
    });

    // set the rail for the variant the page opened on
    (function () {
      var firstId = Object.keys(data)[0];
      var sel = document.querySelector('[data-variant][aria-pressed="true"]');
      if (sel) firstId = sel.getAttribute('data-variant');
      if (data[firstId] && data[firstId].sku) showThumbsFor(data[firstId].sku);
    })();

    // --- zoom on the stage, and a full-screen viewer ---------------------
    var stage = document.querySelector('[data-stage]');
    var lb = document.querySelector('[data-lightbox]');
    var lbImg = lb && lb.querySelector('[data-lb-image]');
    var lbCount = lb && lb.querySelector('[data-lb-count]');
    var gallery = [];
    var galleryEl = document.querySelector('[data-gallery]');
    if (galleryEl) {
      try { gallery = JSON.parse(galleryEl.textContent) || []; } catch (e) { gallery = []; }
    }
    var lbIndex = 0;
    var lastFocus = null;

    function currentIndex() {
      if (!mainImg) return 0;
      var src = mainImg.getAttribute('src') || '';
      var key = src.split('?')[0].split('/').pop();
      for (var i = 0; i < gallery.length; i++) {
        if ((gallery[i] || '').indexOf(key) > -1) return i;
      }
      return 0;
    }
    function showLb(i) {
      if (!gallery.length) return;
      lbIndex = (i + gallery.length) % gallery.length;
      if (lbImg) lbImg.setAttribute('src', gallery[lbIndex]);
      if (lbCount) lbCount.textContent = (lbIndex + 1) + ' of ' + gallery.length;
    }
    function openLb(i) {
      if (!lb || !gallery.length) return;
      lastFocus = document.activeElement;
      showLb(i);
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var c = lb.querySelector('[data-lb-close]');
      if (c) c.focus();
    }
    function closeLb() {
      if (!lb) return;
      lb.hidden = true;
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (stage) {
      // click magnifies in place; the cursor decides what is magnified
      stage.addEventListener('click', function () { stage.classList.toggle('zoom'); });
      stage.addEventListener('mousemove', function (e) {
        if (!stage.classList.contains('zoom') || !mainImg) return;
        var r = stage.getBoundingClientRect();
        mainImg.style.transformOrigin =
          (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
      });
      stage.addEventListener('mouseleave', function () {
        stage.classList.remove('zoom');
        if (mainImg) mainImg.style.transformOrigin = 'center center';
      });
      // keyboard opens the full-screen viewer instead
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(currentIndex()); }
      });
      stage.addEventListener('dblclick', function () {
        stage.classList.remove('zoom');
        openLb(currentIndex());
      });
    }
    if (lb) {
      var pv = lb.querySelector('[data-lb-prev]');
      var nx = lb.querySelector('[data-lb-next]');
      if (pv) pv.addEventListener('click', function () { showLb(lbIndex - 1); });
      if (nx) nx.addEventListener('click', function () { showLb(lbIndex + 1); });
      var cl = lb.querySelector('[data-lb-close]');
      if (cl) cl.addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') showLb(lbIndex - 1);
        if (e.key === 'ArrowRight') showLb(lbIndex + 1);
      });
    }

    var thumbs = [].slice.call(document.querySelectorAll('[data-thumb]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainImg) mainImg.setAttribute('src', t.getAttribute('data-thumb'));
        thumbs.forEach(function (x) { x.setAttribute('aria-current', String(x === t)); });
      });
    });
  }


  var RECENT_KEY = 'lh_recent_v1';

  function recentlyViewed() {
    var selfEl = document.querySelector('[data-recent-self]');
    var section = document.getElementById('recently-viewed');
    var rail = section && section.querySelector('[data-recent-rail]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { list = []; }

    var self = null;
    if (selfEl) {
      try { self = JSON.parse(selfEl.textContent); } catch (e) { self = null; }
    }
    if (self && self.handle) {
      list = list.filter(function (x) { return x.handle !== self.handle; });
      list.unshift(self);
      list = list.slice(0, 8);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
    }
    if (!rail) return;
    var others = list.filter(function (x) { return !self || x.handle !== self.handle; });
    if (others.length < 2) return;
    rail.innerHTML = others.map(function (p) {
      return '<article class="card"><a class="imwrap" href="' + p.url + '">' +
        (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" style="min-width:0;min-height:0">' : '') +
        '</a><div class="body"><span class="cat">' + (p.type || '') + '</span>' +
        '<a class="nm" href="' + p.url + '">' + p.title + '</a>' +
        '<div class="pr"><span class="now price">' + (p.price || '') + '</span></div></div></article>';
    }).join('');
    section.hidden = false;
  }

  // Bind once. The theme editor re-runs section scripts, and a second bind
  // would double every handler, which silently cancels toggles.
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    initProduct();
    recentlyViewed();

    document.querySelectorAll('[data-acc-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
        var panel = b.nextElementSibling;
        if (panel) panel.classList.toggle('open', !open);
      });
    });

    // Mega menu. Hover state is tracked on the whole nav, not per button, so
    // sliding from one department to the next swaps panels instead of closing.
    var megaNav = document.querySelector('nav.primary');
    var navButtons = [].slice.call(document.querySelectorAll('.navlink[data-mega]'));
    var closeTimer = null;

    function closeMega() {
      [].forEach.call(document.querySelectorAll('.mega.open'), function (m) {
        m.classList.remove('open');
      });
      navButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    function openMega(btn) {
      clearTimeout(closeTimer);
      var panel = document.getElementById('mega-' + btn.getAttribute('data-mega'));
      if (!panel) return;
      closeMega();
      panel.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }

    navButtons.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () { openMega(btn); });
      btn.addEventListener('focus', function () { openMega(btn); });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var panel = document.getElementById('mega-' + btn.getAttribute('data-mega'));
        if (panel && panel.classList.contains('open')) {
          window.location.href = '/collections/' + btn.getAttribute('data-mega');
        } else {
          openMega(btn);
        }
      });
    });

    if (megaNav) {
      // one exit point: leaving the nav entirely, panels included
      megaNav.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeMega, 150);
      });
      megaNav.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mega') && !e.target.closest('.navlink[data-mega]')) closeMega();
    });

    // collection filters
    document.querySelectorAll('[data-fgroup]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
      });
    });
    var facetForm = document.querySelector('[data-facet-form]');
    if (facetForm) {
      // auto-apply on change, so there is no Apply button to miss
      facetForm.addEventListener('change', function () { facetForm.submit(); });
    }
    var sortSel = document.querySelector('[data-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sortSel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }
    var panel = document.getElementById('filters');
    document.querySelectorAll('[data-openfilters]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (panel) { panel.classList.add('open'); document.body.style.overflow = 'hidden'; }
      });
    });
    document.querySelectorAll('[data-closefilters]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (panel) { panel.classList.remove('open'); document.body.style.overflow = ''; }
      });
    });

    // --- mobile menu drawer -------------------------------------------
    var burger = document.querySelector('[data-burger]');
    var nav = document.querySelector('[data-mobile-nav]');

    function openNav() {
      if (!nav) return;
      nav.classList.add('open');
      nav.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = nav.querySelector('[data-close-nav]');
      if (first && first.focus) first.focus();
    }
    function closeNav() {
      if (!nav) return;
      nav.classList.remove('open');
      nav.setAttribute('aria-hidden', 'true');
      if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
      document.body.style.overflow = '';
    }

    if (burger && nav) {
      burger.addEventListener('click', function () {
        if (nav.classList.contains('open')) closeNav(); else openNav();
      });
      nav.querySelectorAll('[data-close-nav]').forEach(function (b) {
        b.addEventListener('click', closeNav);
      });
      // one open section at a time keeps the list short enough to scan
      nav.querySelectorAll('[data-macc]').forEach(function (b) {
        b.addEventListener('click', function () {
          var open = b.getAttribute('aria-expanded') === 'true';
          nav.querySelectorAll('[data-macc]').forEach(function (x) {
            x.setAttribute('aria-expanded', 'false');
          });
          b.setAttribute('aria-expanded', String(!open));
          if (!open) {
            var body = nav.querySelector('.body');
            if (body) body.scrollTop = b.offsetTop - 8;
          }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('open')) closeNav();
      });
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
